<template>
  <span
    :class="{
      'input-has-suffix': suffix
    }"
  >
    <input
      class="input"
      :id="inputId"
      :class="{
        block: block,
        'input-with-suffix': suffix,
        'read-only': readOnly,
        'primary-border': primaryBorder,
        'red-border': redBorder || hasError
      }"
      :disabled="disabled"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @keyup.stop
      v-on="{
        ...$listeners,
        input: event => setInput(event)
      }"
    />
    <label :for="inputId" class="suffix" v-if="suffix">{{ suffix }}</label>
  </span>
</template>

<script>
export default {
  name: "VInput",
  props: {
    value: {
      type: [String, Number]
    },
    type: {
      type: String,
      default: "text"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    },
    suffix: {
      type: String
    },
    placeholder: {
      type: String
    },
    hasError: {
      type: Boolean,
      default: false
    },
    primaryBorder: {
      type: Boolean,
      default: false
    },
    redBorder: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      id: Math.random()
    };
  },
  computed: {
    inputId() {
      return `input-${this.id}`;
    }
  },
  methods: {
    setInput(event) {
      if (this.readOnly) {
        event.target.value = this.value;
        this.$forceUpdate();
      } else {
        this.$emit("input", event.target.value);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/variables";

.input {
  padding: 10px;
  font-size: 13px;
  color: $color-black;
  background: $color-white;
  border: 1px solid $color-grey;
  border-radius: 5px;
  outline: none !important;

  &.read-only {
    color: transparent;
    text-shadow: 0 0 0 $color-black;
  }

  &:disabled {
    padding: 10px;
    font-size: 13px;
    color: $color-medium-grey;
  }

  &.block {
    width: 100%;
    display: block;
  }
  &::placeholder {
    font-family: "fsalbertregular";
  }

  &.primary-border {
    border-color: #004593;
  }

  &.red-border {
    border-color: $color-red;
  }
  &.input-with-suffix {
    padding-right: 40px;
    text-align: right;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      /* display: none; <- Crashes Chrome on hover */
      -webkit-appearance: none;
      margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }
  }
}
.input-has-suffix {
  position: relative;
  display: block;
}
.suffix {
  font-size: 13px;
  position: absolute;
  right: 12px;
  top: 0;
  bottom: 0;
  line-height: 42px;
  font-family: "fsalbertregular";
}
</style>
